export const ServicesFixture = ["ELEC", "LPG", "BB"];
